var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWanchainWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.70898 20.9571L8.81579 19.733L14.0325 22.7934L19.1851 19.733L21.3561 20.9571L14.0325 25.375L6.70898 20.9571Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.375 8.68085L7.22721 9.90501V16.7874L14 12.6848L20.838 16.7874V9.90501L23.625 8.68085V21.6527L14 15.8948L4.375 21.6527V8.68085Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.69922 8.15108L14.0002 2.625L23.3664 8.15108L20.8382 9.21059L14.0002 5.20658L7.22739 9.21059L4.69922 8.15108Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWanchainWhite);
export default __webpack_public_path__ + "static/media/wanchain-white.058a0aa32ad0f1c1c6949dda6d24108e.svg";
export { ForwardRef as ReactComponent };